import Spinner from "@rio-cloud/rio-uikit/Spinner";

export const Loading = ({label}: {label?: string}) => (
    <div>
        <div className="loading-spinner">
            <div className="spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div className="spinnerText">{label ?? 'Loading'}</div>
        </div>
    </div>
);

export const FullPageLoading = ({ label }: { label: string }) => (
    <div
        style={{
            position: 'fixed',
            inset: 0,
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
    >
        <Spinner isInline />
        <span style={{ marginLeft: 10 }}>{label}</span>
    </div>
);
